/*
 * ForeFront fixes, round 3 (Oct 21 2026)
 * 1. Canadian spelling: "color" becomes "colour" in visible text (brand names like ColorWorks, iColor, VIPColor are left alone).
 * 2. Removes the iSys note from the supply finder (no iSys printers are listed).
 * 3. Related products: only show labels with the same core and roll size, and ink for the same printer.
 * 4. Search: "candle labels", "cosmetic labels" and similar searches show the matching industry page first.
 */
(function () {
  'use strict';

  /* ---------- 1 + 2. Text rewrites ---------- */
  var RULES = [
    [/\s*iSys Label models are verified individually\.?/g, ''],
    [/\b([Cc])olor(s|ed|ful|ing)?\b/g, function (m, c, s) { return c + 'olour' + (s || ''); }],
    [/\bCOLOR(S)?\b/g, function (m, s) { return 'COLOUR' + (s || ''); }]
  ];
  var SKIP = { SCRIPT: 1, STYLE: 1, TEXTAREA: 1, NOSCRIPT: 1, CODE: 1, PRE: 1 };

  var fixNode = function (node) {
    var before = node.nodeValue;
    if (!before || !/olor|OLOR|iSys/.test(before)) return;
    var after = before;
    for (var i = 0; i < RULES.length; i += 1) after = after.replace(RULES[i][0], RULES[i][1]);
    if (after !== before) node.nodeValue = after;
  };

  var fixTree = function (root) {
    if (!root) return;
    if (root.nodeType === 3) {
      if (root.parentNode && !SKIP[root.parentNode.nodeName] && !root.parentNode.isContentEditable) fixNode(root);
      return;
    }
    if (root.nodeType !== 1 || SKIP[root.nodeName] || root.isContentEditable) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        var p = n.parentNode;
        if (!p || SKIP[p.nodeName] || p.isContentEditable) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var n;
    while ((n = walker.nextNode())) fixNode(n);
  };

  var pending = [];
  var scheduled = false;
  var flush = function () {
    scheduled = false;
    var list = pending;
    pending = [];
    observer.disconnect();
    for (var i = 0; i < list.length; i += 1) if (list[i].isConnected) fixTree(list[i]);
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
  };
  var observer = new MutationObserver(function (records) {
    for (var i = 0; i < records.length; i += 1) {
      var r = records[i];
      if (r.type === 'characterData') pending.push(r.target);
      else for (var j = 0; j < r.addedNodes.length; j += 1) pending.push(r.addedNodes[j]);
    }
    if (!scheduled && pending.length) { scheduled = true; window.requestAnimationFrame(flush); }
  });

  /* ---------- 3. Related products that fit the same printer ---------- */
  var current = window.FF_PRODUCT || null;
  var MODEL_RE = /\b(CW-[A-Z]\d{4}[A-Z]?|TM-C\d{4}[A-Z]?|LX\s?\d{3,4}|L\d{3}|VP\d{3})\b/gi;
  var coreOf = function (t) {
    var m = /(\d(?:\.\d)?)"\s*Core,\s*(\d+)"\s*OD/i.exec(t || '');
    return m ? m[1] + 'C' + m[2] : '';
  };
  var normModel = function (m) { return m.toUpperCase().replace(/\s+/g, '').replace(/^(CW|TM)-C(\d{4})[AP]$/, '$1-C$2'); };
  var modelsOf = function (text) {
    var out = [];
    String(text || '').replace(MODEL_RE, function (m) { out.push(normModel(m)); return m; });
    return out;
  };

  var keepCard = function (title) {
    if (!current) return true;
    var src = current.title || '';
    var srcType = (current.type || '').toLowerCase();
    var srcTags = (current.tags || []).join(' | ');
    var isInk = /\bink\b/i.test(title) && !/inkjet labels/i.test(title);
    var isLabel = /labels?\b/i.test(title) && !isInk;
    var srcIsThermal = /thermal/.test(srcType) && /label/.test(srcType) && !/printer/.test(srcType);
    var srcIsInkjetLabel = /inkjet labels/.test(srcType) || /inkjet labels/i.test(src);
    var srcIsPrinter = /printer/i.test(src) && !srcIsInkjetLabel && !/\bink\b/i.test(src);

    if (srcIsThermal) return /thermal/i.test(title);
    if (srcIsInkjetLabel) {
      if (/thermal/i.test(title)) return false;
      var a = coreOf(src), b = coreOf(title);
      if (isLabel && a && b && a !== b) return false;
      if (isInk) {
        var fits = modelsOf(srcTags + ' ' + src);
        var inkModels = modelsOf(title);
        if (inkModels.length && fits.length) return inkModels.some(function (m) { return fits.indexOf(m) !== -1; });
      }
      return true;
    }
    if (srcIsPrinter) {
      if (/LabelWorks|LW-PX/i.test(title) && !/LabelWorks|LW-PX/i.test(src)) return false;
      if (isInk) {
        var mine = modelsOf(src);
        var theirs = modelsOf(title);
        if (mine.length && theirs.length) return theirs.some(function (m) { return mine.indexOf(m) !== -1; });
      }
      return true;
    }
    return true;
  };

  var filterRecommendations = function (html) {
    try {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var cards = doc.querySelectorAll('.product');
      if (!cards.length) return html;
      var removed = [];
      cards.forEach(function (card) {
        var link = card.querySelector('.card-title, .card-information__text, a[href*="/products/"][title], a[href*="/products/"]');
        var title = (link && (link.getAttribute('title') || link.textContent)) || card.textContent;
        title = String(title).replace(/\s+/g, ' ').trim();
        if (!keepCard(title)) removed.push(card);
      });
      if (removed.length === cards.length) return html;
      removed.forEach(function (c) { c.parentNode.removeChild(c); });
      // On printer pages, show this printer's ink first.
      if (current && /printer/i.test(current.title || '') && !/labels?\b/i.test(current.type || '')) {
        var inks = [];
        doc.querySelectorAll('.product').forEach(function (card) { if (/\bink\b/i.test(card.textContent) && !/inkjet labels/i.test(card.textContent)) inks.push(card); });
        for (var k = inks.length - 1; k >= 0; k -= 1) inks[k].parentNode.insertBefore(inks[k], inks[k].parentNode.firstElementChild);
      }
      var left = cards.length - removed.length;
      doc.querySelectorAll('.slider-counter--total').forEach(function (el) { el.textContent = left; });
      return '<!DOCTYPE html>' + doc.documentElement.outerHTML;
    } catch (e) { return html; }
  };

  var isRecUrl = function (u) { return /\/recommendations\/products/.test(String(u || '')); };

  if (current && window.fetch) {
    var nativeFetch = window.fetch;
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url);
      var p = nativeFetch.apply(this, arguments);
      if (!isRecUrl(url) || /\.json/.test(url)) return p;
      return p.then(function (res) {
        if (!res.ok) return res;
        return res.clone().text().then(function (text) {
          return new Response(filterRecommendations(text), { status: res.status, statusText: res.statusText, headers: res.headers });
        }).catch(function () { return res; });
      });
    };
  }
  var hookJquery = function () {
    var $ = window.jQuery;
    if (!current || !$ || !$.ajaxPrefilter || $.__ffRec) return;
    $.__ffRec = true;
    $.ajaxPrefilter(function (opts) {
      if (!isRecUrl(opts.url) || /\.json/.test(opts.url)) return;
      var prev = opts.dataFilter;
      opts.dataFilter = function (data, type) {
        if (prev) data = prev(data, type);
        return typeof data === 'string' ? filterRecommendations(data) : data;
      };
    });
  };

  /* ---------- 4. Industry pages in search ---------- */
  var INDUSTRIES = [
    [/candle|wax melt/, '/pages/candle-labels-canada', 'Candle labels', 'Label sizes, materials and tips for candle makers'],
    [/water bottle|bottle|beverage|drink|brew|wine|beer/, '/pages/water-bottle-label', 'Bottle and beverage labels', 'Waterproof labels for bottles and drinks'],
    [/cosmetic|beauty|skin ?care|soap|lotion|makeup/, '/pages/cosmetic-labeling-guide-canada', 'Cosmetic labels', 'Labelling guide for cosmetics in Canada'],
    [/cannabis|weed|thc|cbd|dispensary/, '/pages/cannabis-labels-canada', 'Cannabis labels', 'Compliant labels for cannabis products'],
    [/supplement|nutraceutical|vitamin|natural health|protein/, '/pages/nutraceuticals-supplements', 'Supplement labels', 'Labels for supplements and natural health products'],
    [/warehouse|logistic|barcode|inventory/, '/pages/warehouse-logistics-labels', 'Warehouse and logistics labels', 'Barcode, shipping and inventory labels'],
    [/e-?commerce|fulfil|retail|online store/, '/pages/e-commerce-retail-fulfillment-labels', 'E-commerce and retail labels', 'Shipping and product labels for online sellers'],
    [/industrial|electronic|parts|asset tag/, '/pages/industrial-parts-electronics-label', 'Industrial and electronics labels', 'Durable labels for parts and equipment'],
    [/\blab\b|laborator|hospital|healthcare|health care|universit|school|specimen/, '/pages/institutions-labs-healthcare-universities', 'Lab, healthcare and university labels', 'Labels for labs, clinics and campuses'],
    [/print shop|reseller|wholesale|print broker/, '/pages/print-shops-wholesale-label-resellers', 'Print shops and resellers', 'Wholesale label rolls for print businesses'],
    [/food|coffee|jar|honey|sauce|bakery|spice|product label/, '/pages/product-label-printing', 'Product label printing', 'Print your own product labels in house']
  ];
  var industryFor = function (q) {
    q = String(q || '').toLowerCase();
    if (q.length < 3) return null;
    for (var i = 0; i < INDUSTRIES.length; i += 1) if (INDUSTRIES[i][0].test(q)) return INDUSTRIES[i];
    return null;
  };
  var esc = function (s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };

  var decorateDropdown = function (box) {
    if (!box || box.__ffBusy) return;
    var form = box.closest('form') || document;
    var input = form.querySelector('input[name="q"]');
    var hit = industryFor(input && input.value);
    var existing = box.querySelector('[data-ff-industry]');
    if (!hit) { if (existing) existing.remove(); return; }
    if (existing && existing.getAttribute('href') === hit[1]) return;
    if (existing) existing.remove();
    box.__ffBusy = true;
    var wrap = document.createElement('div');
    wrap.setAttribute('data-ff-industry', '');
    wrap.setAttribute('href', hit[1]);
    wrap.innerHTML = '<p class="ffx-search-results__heading" role="presentation">Shop by industry</p>' +
      '<a class="ffx-search-result ff-industry-result" href="' + hit[1] + '" role="option" aria-selected="false" tabindex="-1">' +
      '<span class="ff-industry-icon" aria-hidden="true">&#9733;</span><span><strong>' + esc(hit[2]) + '</strong><small>' + esc(hit[3]) + '</small></span></a>';
    box.insertBefore(wrap, box.firstChild);
    box.__ffBusy = false;
  };

  var watchDropdowns = function () {
    document.querySelectorAll('.ffx-search-results').forEach(function (box) {
      if (box.__ffWatched) return;
      box.__ffWatched = true;
      new MutationObserver(function () { if (!box.__ffBusy) decorateDropdown(box); }).observe(box, { childList: true });
      decorateDropdown(box);
    });
  };

  var decorateSearchPage = function () {
    if (!/^\/search/.test(location.pathname)) return;
    var q = new URLSearchParams(location.search).get('q');
    var hit = industryFor(q);
    var main = document.getElementById('MainContent');
    if (!hit || !main || main.querySelector('[data-ff-industry-banner]')) return;
    var box = document.createElement('a');
    box.setAttribute('data-ff-industry-banner', '');
    box.href = hit[1];
    box.className = 'ff-industry-banner';
    box.innerHTML = '<span><small>Shop by industry</small><strong>' + esc(hit[2]) + '</strong><em>' + esc(hit[3]) + '</em></span><b aria-hidden="true">&rarr;</b>';
    var anchor = main.querySelector('h1, .page-header, .halo-page-header');
    if (anchor) anchor.insertAdjacentElement('afterend', box);
    else main.insertBefore(box, main.firstChild);
  };

  var start = function () {
    hookJquery();
    fixTree(document.body);
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
    watchDropdowns();
    decorateSearchPage();
    document.addEventListener('input', function (e) {
      if (e.target && e.target.name === 'q') window.setTimeout(watchDropdowns, 50);
    }, true);
  };

  hookJquery();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
